import { Directive, ElementRef, inject, input } from '@angular/core';
import { DataService } from '@core/services';

@Directive({
  selector: '[b2cElement]',
  host: {
    '(click)': 'onClick()',
  },
})
export class ElementDirective {
  modalType = input<'select' | 'unselect' | 'scanner'>('select');

  private readonly el = inject(ElementRef);
  private readonly dataService = inject(DataService);

  onClick() {
    this.dataService.objectRef.set({
      element: this.el,
      type: this.modalType(),
    });
  }
}
